import { render, staticRenderFns } from "./PermissionFormModal.vue?vue&type=template&id=667cc1a4&scoped=true"
import script from "./PermissionFormModal.vue?vue&type=script&lang=js"
export * from "./PermissionFormModal.vue?vue&type=script&lang=js"
import style0 from "./PermissionFormModal.vue?vue&type=style&index=0&id=667cc1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667cc1a4",
  null
  
)

export default component.exports